module.exports = __webpack_public_path__ + "img/disable-forwarded.de6c8227.png";